"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.segmentType = exports.TRANSLATION = exports.TEXT_TYPE = exports.TAG = exports.SIZE = exports.PRICE_TEXT_TYPE = exports.ICON_TYPES = exports.COLOR_TYPES = exports.COLOR = exports.CBWT = exports.BAGGAGE_TYPES = exports.BAGGAGE_ICONS = void 0;
var TEXT_TYPE = {
  HEADING: {
    type: 'textNormal',
    color: 'neutral'
  },
  DESC: {
    type: 'textNormal',
    color: 'greyDark'
  },
  MOBILE_DESC: {
    type: 'small',
    color: 'greyDark'
  },
  STATUS: {
    type: 'small',
    color: 'tertiary',
    fontWeight: 'semiLarge'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var COLOR_TYPES = {
  selected: 'secondary',
  notSelected: 'greyLight',
  sportsEquipmentLabel: 'secondary',
  title: 'neutral',
  included: 'tertiaryDark'
};
exports.COLOR_TYPES = COLOR_TYPES;
var BAGGAGE_TYPES = {
  checkedBaggage: 'checkedBaggage',
  handCarry: 'handCarry',
  sportsEquip: 'sportsEquip'
};
exports.BAGGAGE_TYPES = BAGGAGE_TYPES;
var ICON_TYPES = {
  plus: {
    color: 'greyDark',
    size: 'titleMedium',
    icon: 'AddIcon'
  }
};
exports.ICON_TYPES = ICON_TYPES;
var PRICE_TEXT_TYPE = {
  normal: {
    color: 'neutral',
    fontSize: 'small',
    currencySize: 'textLarge'
  }
};
exports.PRICE_TEXT_TYPE = PRICE_TEXT_TYPE;
var TAG = {
  div: 'div',
  span: 'span'
};
exports.TAG = TAG;
var BAGGAGE_ICONS = {
  handCarry: {
    type: 'SmallBaggage',
    color: 'greyDark',
    size: 'titleSmall'
  },
  checkedBaggage: {
    type: 'LargeBaggage',
    color: 'greyDark',
    size: 'titleSmall'
  },
  sportsEquip: {
    type: 'SportsEquipment',
    color: 'greyDark',
    size: 'titleSmall'
  }
};
exports.BAGGAGE_ICONS = BAGGAGE_ICONS;
var TRANSLATION = {
  included: 'Included',
  bundle: 'Bundle',
  handCarry: 'Carry-on Baggage',
  checkedBaggage: 'Checked Baggage',
  sportsEquip: 'Sports Equipment',
  handCarryToolTipTitle: 'What is a hand carry?',
  handCarryToolTipLabel: 'This is a bag you carry on board the aircraft. You must store it in the overhead compartment.',
  none: 'None',
  sportsEquipmentLabel: 'I want sports equipment',
  handCarrySizeDesc: 'Baggage size must not exceed  40 x 20 x 25 cm per piece',
  unavailable: 'Unavailable',
  baggageUnAvailableNotification: 'Some options are unavailable due to aircraft weight limits.'
};
exports.TRANSLATION = TRANSLATION;
var segmentType = {
  segmentByWeight: 'segmentByWeight'
};
exports.segmentType = segmentType;
var COLOR = {
  green: 'green'
};
exports.COLOR = COLOR;
var SIZE = {
  medium: 'medium',
  small: 'small',
  normal: 'normal'
};
exports.SIZE = SIZE;
var CBWT = 'CBWT';
exports.CBWT = CBWT;